export default {
  roundtrip: {
    roundtripOptions: 'Opțiuni de călătorie dus-întors',
  }
}
